import React from "react";
import MainHeader from "./Main/Header"
// import MainFooter from "./Main/Footer"
import Profile from "./Main/Profile"
import Works from "./Main/Works"
// import Account from "./Main/Account"

const components = {
  'Profile': Profile,
  'Works': Works
};

export default class Main extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      content: 'Profile'
    };

    this.changeContent = this.changeContent.bind(this);
  }

  componentDidMount() {
    this.props.setFunc((e) => this.changeContent(e));
  }

  changeContent(contentName) {
    this.setState({ content: contentName });
  }

  render() {
        return (
        <div className="main">
          {React.createElement(components[this.state.content])}
        </div>
      );
    }
  }
